export default __webpack_public_path__ + "static/media/muma.8acdb439.png";